<template>
  <dialog class="modal">
    <div class="modal-box">
      <form method="dialog">
        <div class="w-full">
          <ButtonClose />
        </div>
      </form>
      <slot></slot>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button>close</button>
    </form>
  </dialog>
</template>
<script setup lang="ts"></script>
